'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _constants = require('../constants');

var _constants2 = _interopRequireDefault(_constants);

var Card = function Card(props) {
    var style = {
        backgroundColor: 'white',
        borderRadius: _constants2['default'].borderRadius.sm,
        boxShadow: '0 2px 3px rgba(0, 0, 0, 0.075), 0 0 0 1px rgba(0,0,0,0.1)',
        marginBottom: _constants2['default'].spacing.md,
        padding: _constants2['default'].spacing.md
    };
    return _react2['default'].createElement('div', _extends({}, props, { style: _extends(style, props.style) }));
};

Card.propTypes = {
    style: _propTypes2['default'].object
};

module.exports = Card;


//////////////////
// WEBPACK FOOTER
// /smarthelpnodeweb-ci-5863/workspace/Release_Build/~/kepler/lib/components/Card.js
// module id = 957
// module chunks = 0 1